import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
   providedIn: 'root',
})
export class ReviewService {
   private domainName = 'Review';

   constructor(private apiService: ApiService) {}

   save(companyId: number, rating: number, reviewRating: string, createdBy: string) {
      return this.apiService.post(`${this.domainName}`, {
         rating,
         reviewRating,
         origin: 'menu',
         companyId,
         createdBy,
      });
   }
}
